import { ModalFlow } from "../../../../shared/components/ModalFlow/ModalFlow";
import { ModalFlowState } from "../../../../shared/components/ModalFlow/types";
import { useModalFlow } from "../../../../shared/components/ModalFlow/useModalFlow";

import { Step1 } from "./Step1";
import { Step2 } from "./Step2";
import { Step3 } from "./Step3";
import { Success } from "./Success";
import { FlowUploadDocumentProps } from "./types";
import { useModalConfirmExit } from "./useModalConfirmExit";

const initialState: ModalFlowState<FlowUploadDocumentProps> = {
  state: {}
};

type FlowUploadDocumentComponentProps = {
  onClose: () => void;
  onFinish: (status: "success" | "cancel") => void;
};

export const MODAL_UPLOAD_FLOW_STORAGE_KEY = "MODAL_UPLOAD_FLOW_STORAGE_KEY";

export const FlowUploadDocument: React.FC<FlowUploadDocumentComponentProps> = ({
  onClose,
  onFinish
}) => {
  const confirmExitModal = useModalConfirmExit();

  return (
    <ModalFlow<FlowUploadDocumentProps>
      confirmExitModal={confirmExitModal}
      defaultStatuses
      historyStateKey={MODAL_UPLOAD_FLOW_STORAGE_KEY}
      initialState={initialState}
      sideSteps={[
        {
          component: Success,
          key: "success",
          title: "Success"
        }
      ]}
      steps={[
        {
          key: "InsuranceDocumentUpload",
          steps: [
            {
              component: Step1,
              key: "intro",
              title: "Intro"
            },
            {
              component: Step2,
              confirmExit: true,
              key: "uploading",
              title: "Upload document"
            },
            {
              component: Step3,
              confirmExit: true,
              key: "importing",
              title: "Complete import"
            }
          ],
          title: "Insurance document upload"
        }
      ]}
      title="Insurance document upload"
      onClose={onClose}
      onFinish={onFinish}
    />
  );
};

type UseFlowUploadDocumentProps = {
  onFinish: (status: "success" | "cancel") => void;
};

export const useFlowUploadDocument = (props: UseFlowUploadDocumentProps) => {
  return useModalFlow({
    Component: FlowUploadDocument,
    flowName: "upload-document",
    getProps() {
      return {};
    },
    onFinish: props.onFinish
  });
};
